:where(.divider) {
  border: 0;
  background-color: transparent;
  border-top: 1px solid;
  margin-top: var(--dds-spacing-x1);
  margin-bottom: var(--dds-spacing-x1);
}

.divider--default {
  color: var(--dds-color-border-default);
}

.divider--subtle {
  color: var(--dds-color-border-subtle);
}

.divider--on-inverse {
  color: var(--dds-color-border-inverse);
}
